
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M12.1429 9.80488C13.3333 9.80488 14.2857 10.7805 14.2857 12C14.2857 13.2195 13.3333 14.1951 12.1429 14.1951C10.9524 14.1951 10 13.2195 10 12C10 10.7805 10.9524 9.80488 12.1429 9.80488ZM10 4.19512C10 5.41463 10.9524 6.39024 12.1429 6.39024C13.3333 6.39024 14.2857 5.41463 14.2857 4.19512C14.2857 2.97561 13.3333 2 12.1429 2C10.9524 2 10 2.97561 10 4.19512ZM10 19.8049C10 21.0244 10.9524 22 12.1429 22C13.3333 22 14.2857 21.0244 14.2857 19.8049C14.2857 18.5854 13.3333 17.6098 12.1429 17.6098C10.9524 17.6098 10 18.5854 10 19.8049Z",
        "fill": "#40454E"
      }
    }
  ]
})
    }
  